import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import './Login.css';

const Login: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(username, password, remember);
      navigate('/admin/genera-buono');
    } catch (err: any) {
      if (err.code === 'ECONNABORTED' || err.message?.includes('timeout')) {
        setError('Il server non risponde. Verifica che il backend Laravel sia avviato (php artisan serve su localhost:8000) e che l\'URL in .env (REACT_APP_API_URL) sia corretto.');
      } else if (err.code === 'ERR_NETWORK') {
        setError('Impossibile raggiungere il server. Controlla che il backend sia avviato e che non ci siano firewall che bloccano la connessione.');
      } else {
        setError(err.response?.data?.message || err.response?.data?.errors?.username?.[0] || 'Errore durante il login');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-wrapper">
        <div className="login-card">
          <div className="login-header">
            <h1>Accedi al tuo account</h1>
            <p>Benvenuto, inserisci le tue credenziali</p>
          </div>

          {error && <Alert variant="danger" className="login-alert">{error}</Alert>}

          <Form onSubmit={handleSubmit} className="login-form">
            <div className="login-field">
              <Form.Label>Nome Utente</Form.Label>
              <Form.Control
                type="text"
                placeholder="Scrivi qui il tuo nome utente"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                className="login-input"
              />
            </div>

            <div className="login-field">
              <Form.Label>Password</Form.Label>
              <div className="login-password-wrap">
                <Form.Control
                  type={showPassword ? 'text' : 'password'}
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="login-input"
                />
                <button
                  type="button"
                  className="login-password-toggle"
                  onClick={() => setShowPassword((v) => !v)}
                  aria-label={showPassword ? 'Nascondi password' : 'Mostra password'}
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.333 8s2.667-4 6.667-4 6.667 4 6.667 4-2.667 4-6.667 4-6.667-4-6.667-4z" stroke="#99A1AF" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" stroke="#99A1AF" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>

            <Button type="submit" className="login-submit" disabled={loading}>
              {loading ? 'Accesso in corso...' : 'ACCEDI'}
            </Button>

            <div className="login-meta">
              <label className="login-remember">
                <Form.Check
                  type="checkbox"
                  checked={remember}
                  onChange={(e) => setRemember(e.target.checked)}
                  className="login-checkbox"
                />
                <span>Ricordami</span>
              </label>
              <Link to="/forgot-password" className="login-forgot">
                Password dimenticata?
              </Link>
            </div>
          </Form>
        </div>

        <p className="login-footer">© 2021 All rights reserved Estetica Cruciani</p>
      </div>
    </div>
  );
};

export default Login;
